<div *ngIf="isReady && paging && endTo > 0" class="paging">
    <div class="page-size-container" *ngIf="!total || sizes[0] < total">
        <select [(ngModel)]="paging.pageSize" (change)="onPageSizeChanged($event);" class="form-control">
            <option *ngFor="let size of sizes" value="{{size}}">{{size}}</option>
        </select>
        <span class="paging-per-page-text">Per page</span>
    </div>
    <div class="pages-container">
        <button *ngIf="paging.currentPage > 0" (click)="onFirst($event)"
            class="paging-first-page-btn paging-btn btn btn-default">
            <i class="fa fa-step-backward"></i>
        </button>
        <button *ngIf="paging.currentPage > 0" (click)="onPrevious($event)"
            class="paging-previous-page-btn paging-btn btn btn-default">
            <i class="fa fa-arrow-left"></i>
        </button>
        <div class="page-info">
            <span class="displayed-range-from-to">{{startFrom}} - {{endTo}}</span>
            <span class="displayed-range-of">&nbsp;of&nbsp;</span>
            <span *ngIf="total" class="paging-total-number">{{total}}</span>
            <a *ngIf="!total && !isLoading" (click)="onRequestTotal($event)" class="paging-total-btn"
                href="javascript:void(0)"></a>
            <div *ngIf="!total && isLoading" class="loader progress-circle-indeterminate progress-circle-complete">
            </div>
        </div>
        <button *ngIf="isNextPageAvailable" (click)="onNext($event)"
            class="paging-next-page-btn paging-btn btn btn-default">
            <i class="fa fa-arrow-right"></i>
        </button>
        <button *ngIf="isNextPageAvailable && total" (click)="onLast($event)"
            class="paging-last-page-btn paging-btn btn btn-default">
            <i class="fa fa-step-forward"></i>
        </button>
    </div>
</div>